export default [
  {nome: 'Casado(a)', codigo: 'CASADO'},
  {nome: 'Divorciado(a)', codigo: 'DIVORCIADO'},
  {nome: 'Separado(a)', codigo: 'SEPARADO'},
  {nome: 'Solteiro(a)', codigo: 'SOLTEIRO'},
  {nome: 'União Estável', codigo: 'UNIAO_ESTAVEL'},
  {nome: 'União Homoafetiva', codigo: 'UNIAO_HOMOAFETIVA'},
  {nome: 'Viúvo(a)', codigo: 'VIUVO'}
]



// WEBPACK FOOTER //
// ./src/constants/estadoCivil.js